import * as React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { FieldWrapper } from '@progress/kendo-react-form';
 

const WtBgChkbox = (props) => {
 
    const [checkedValue, setCheckedValue] = React.useState(props.checkedValue);

    const handleCheckedChange = (event) => {
        setCheckedValue(event.value);
        props.onCheckedChange(event.value,props.id);
    }

    return(
        <FieldWrapper style={{paddingLeft:'3%',paddingRight:'3%'}}>
        <div style={{position:'relative',borderRadius:'10rem', margin:'0 auto', boxShadow:'0 0 5rem #b5b5b5', backgroundColor:'#fff'}}>
            <div className="row around-xs inputPair elementVisible" style={{paddingTop:'8px',paddingBottom:'12px'}}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                    {/* <div className="box">
                        <Checkbox id={props.id} checked={checkedValue} onChange={handleCheckedChange} style={{verticalAlign:'middle'}}
                            disabled={props.disabled} /> 
                        <label className={"k-checkbox-label"} style={{display: "inline-block"}}>{props.label}</label>
                    </div> */}
                   
                    <div style={{width:'8%',float:'left'}}>
                    <Checkbox id={props.id} checked={checkedValue} onChange={handleCheckedChange} disabled={props.disabled}/>
                    </div>
                    <div style={{width:'92%',float:'left' }}>
                        <label className={'k-checkbox-label'}>{props.label}</label>
                    </div>
                    
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div className="box" >
                        <span className="k-state-default">
                            <label className="k-checkbox-label">
                                {props.rightLabel}
                            </label> 
                        </span>
                    </div>
                </div>
            </div>
        </div>          
    </FieldWrapper>
   
    )
}

export default WtBgChkbox;